import BankMoneyMovement from '@/modules/money/movement/domain/bankMoneyMovement'

export default class MoneyMovementSplit {
  originalMovement?: BankMoneyMovement | null = null
  newMovements: Array<BankMoneyMovement> = []
  note?: string | null = null
  _updateRelations: Array<string> = ['newMovements']
}
